import { useState, useMemo } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Header } from './Header';
import { StatusBar } from './StatusBar';
import { AIPicks } from '../sidebar/AIPicks';
import { TodayStats } from '../sidebar/TodayStats';
import { MarketProvider, useMarketContext } from '../../contexts/MarketContext';

function LayoutContent() {
  const [searchQuery, setSearchQuery] = useState('');
  const [activeSport, setActiveSport] = useState('nba');
  const [activeFilter, setActiveFilter] = useState('all');
  const { markets, predictions } = useMarketContext();
  const location = useLocation();

  // 检查是否在详情页
  const isDetailPage = location.pathname.startsWith('/market/');
  // Calculate filter counts
  const filterCounts = useMemo(() => {
    const all = markets?.length || 0;
    const live = markets?.filter(m => m.status === 'live').length || 0;
    const upcoming = markets?.filter(m => m.status === 'upcoming').length || 0;
    const ended = markets?.filter(m => m.status === 'ended').length || 0;
    return { all, live, upcoming, ended };
  }, [markets]);

  // Markets with AI pick flag for stats
  const marketsWithFlags = useMemo(() => {
    return markets.map((m) => ({
      ...m,
      hasAIPick: predictions[m.id]?.ev > 0,
    }));
  }, [markets, predictions]);
  const hasAIPicks = useMemo(
    () => marketsWithFlags.some((market) => market.hasAIPick),
    [marketsWithFlags]
  );

  return (
    <div className="h-screen flex flex-col text-slate-100 overflow-hidden">

      <Header
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        activeSport={activeSport}
        onSportChange={setActiveSport}
        activeFilter={activeFilter}
        onFilterChange={setActiveFilter}
        filterCounts={filterCounts}
      />

      <div className="flex-1 flex overflow-hidden relative gap-4 max-w-[2000px] mx-auto w-full p-4">
        {/* Left Sidebar: AI Picks + Today Stats */}
        {!isDetailPage && (
          <div className="hidden xl:flex flex-col gap-4 shrink-0 w-80 overflow-y-auto scrollbar-none pb-20">
            {hasAIPicks && <AIPicks />}
            <div className="shrink-0">
              <TodayStats markets={marketsWithFlags} />
            </div>
          </div>
        )}

        {/* Main Content (scrollable) */}
        <main className="flex-1 overflow-auto rounded-xl scrollbar-none pb-20">
          <Outlet context={{ searchQuery, activeSport, activeFilter }} />
        </main>

      </div>

      <StatusBar />
    </div>
  );
}

export function Layout() {
  return (
    <MarketProvider>
      <LayoutContent />
    </MarketProvider>
  );
}
